import { computed } from 'mobx';
import { observer } from 'mobx-react';
import Moment from 'moment';
import React from 'react';
import { withRouter } from 'react-router-dom';

@withRouter
@observer
class Attachment extends React.Component {
  render() {
    let { size, timeStamp } = this;
    const { name, extension } = this.props;

    return (
      <tr>
        <td>{name}</td>
        <td>{timeStamp}</td>
        <td>{extension}</td>
        <td>{size}</td>
        <td>
          <a href={this.href} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        </td>
      </tr>
    );
  }

  @computed
  get timeStamp() {
    let { dateCreated } = this.props;
    return new Moment(dateCreated).format('DD/MM/YYYY HH:mm');
  }

  @computed
  get size() {
    const mb = 1000;
    const gb = 1000000;
    let { fileSize } = this.props;

    if (fileSize < mb) return `${fileSize} KB`;
    if (fileSize < gb) return `${fileSize / mb} MB`;
    return `${fileSize / gb} GB`;
  }

  @computed
  get href() {
    let { name, match } = this.props;
    let { caseId } = match.params;
    return `/api/cases/${caseId}/attachments/${name}`;
  }
}

export default Attachment;
